import { useEffect, useState } from 'react';
import styles from './FiltroTipos.module.css';

const FiltroTipos = ({ tipos, tiposSeleccionados, onTipoChange, onClose }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Cerrar con Escape y manejar scroll del body solo en móviles
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && onClose && isMobile) {
                onClose();
            }
        };

        if (isMobile) {
            document.addEventListener('keydown', handleEscape);
            // Prevenir scroll del body solo en móviles
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            if (isMobile) {
                document.body.style.overflow = 'unset';
            }
        };
    }, [isMobile, onClose]);

    const toggleAll = () => {
        const allSelected = tipos.every(tipo => tiposSeleccionados.includes(tipo.id));
        if (allSelected) {
            // Deseleccionar todos
            tipos.forEach(tipo => {
                if (tiposSeleccionados.includes(tipo.id)) {
                    onTipoChange(tipo.id);
                }
            });
        } else {
            // Seleccionar todos
            tipos.forEach(tipo => {
                if (!tiposSeleccionados.includes(tipo.id)) {
                    onTipoChange(tipo.id);
                }
            });
        }
    };

    const allSelected = tipos.every(tipo => tiposSeleccionados.includes(tipo.id));

    return (
        <>
            {/* Overlay solo en móviles */}
            {isMobile && onClose && (
                <div className={styles.filtroOverlay} onClick={onClose} />
            )}
            
            <div className={styles.filtroContainer}>
                <div className={styles.filtroHeader}>
                    <h3>{isMobile ? 'Filtrar por tipo' : 'Filtrar por tipo de universidad'}</h3>
                    {isMobile && onClose && (
                        <button 
                            className={styles.closeBtn}
                            onClick={onClose}
                            aria-label="Cerrar filtro"
                        >
                            ×
                        </button>
                    )}
                    <button 
                        className={styles.toggleAllBtn}
                        onClick={toggleAll}
                    >
                        {allSelected ? 'Deseleccionar todo' : 'Seleccionar todo'}
                    </button>
                </div>
                
                <div className={styles.tiposList}>
                    {tipos.map(tipo => (
                        <label key={tipo.id} className={styles.tipoItem}>
                            <input
                                type="checkbox"
                                checked={tiposSeleccionados.includes(tipo.id)}
                                onChange={() => onTipoChange(tipo.id)}
                                className={styles.checkbox}
                            />
                            <span className={styles.tipoNombre}>{tipo.nombre}</span>
                        </label>
                    ))}
                </div>
            </div>
        </>
    );
};

export default FiltroTipos;